import { TApplicationState } from '../../types/redux';

export const selectIsNewDreamOnboardingOpen = (state: TApplicationState) =>
  state.page.modals.newDreamOnboardingModalOpen;

export const selectIsHomeProfitOnboardingOpen = (state: TApplicationState) =>
  state.page.modals.homeProfileOnboardingModalOpen;
